
import React from 'react';
import { Button } from '@/components/ui/button';
import CalendlyButton from '../CalendlyButton';

interface AssessmentCompleteActionsProps {
  calendlyUrl?: string;
  onRestart: () => void;
  onExit: () => void;
  onDownloadReport: () => Promise<void>;
  personalInfo?: {
    fullName: string;
    email: string;
    company: string;
    designation: string;
  };
  assessmentTitle?: string;
  pdfUrl?: string;
}

const AssessmentCompleteActions: React.FC<AssessmentCompleteActionsProps> = ({
  calendlyUrl = 'https://calendly.com/gihan-gapstars',
  onRestart,
  onExit,
  onDownloadReport,
  personalInfo,
  assessmentTitle,
  pdfUrl
}) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between gap-4 border-t p-6">
      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
        <Button
          variant="outline"
          onClick={onRestart}
          className="w-full sm:w-auto"
        >
          Restart Assessment
        </Button>
      </div>
      
      <div className="flex gap-4 w-full sm:w-auto">
        <CalendlyButton 
          calendlyUrl={calendlyUrl}
          className="w-full sm:w-auto"
          personalInfo={personalInfo}
          assessmentTitle={assessmentTitle}
          pdfUrl={pdfUrl}
        />
      </div>
    </div>
  );
};

export default AssessmentCompleteActions;
